import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { useDispatch } from 'react-redux';
import { useLangField } from '../../../../hooks/useLangField';
import { deleteEvent } from '../../../../redux/asyncActions/listEvent';
import { useUniqueFilters } from '../useUniqueFilters';

export const useTableColumnsListEvent = (listEvent, onEdit) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const getLangField = useLangField();
  const chapterFilters = useUniqueFilters(listEvent, (e) => e.chapter);
  const categoryFilters = useUniqueFilters(listEvent, (e) => e.category);
  const subCategoryFilters = useUniqueFilters(listEvent, (e) => e.subCategory);
  const orgTypeFilters = useUniqueFilters(
    listEvent,
    (e) => e.orgType,
    (org) => getLangField(org, 'name'),
    [getLangField]
  );

  const handleClickEdit = (record) => () => {
    onEdit(record);
  };

  const handleClickDelete = (id) => () => {
    dispatch(deleteEvent(id));
  };

  return [
    {
      title: t('governmentServiceEducation.serialNumber'),
      dataIndex: 'serialNumber',
      align: 'center',
      width: 70,
    },
    {
      title: t('governmentServiceEducation.chapter'),
      dataIndex: 'chapter',
      align: 'center',
      render: (_, record) => record && record.chapter && record.chapter.name,
      filters: chapterFilters,
      onFilter: (value, record) => record.chapter && record.chapter.id === value,
      filterSearch: true,
    },
    {
      title: t('governmentServiceEducation.category'),
      dataIndex: 'category',
      align: 'center',
      render: (_, record) => record && record.category && record.category.name,
      filters: categoryFilters,
      onFilter: (value, record) => record.category && record.category.id === value,
      filterSearch: true,
    },
    {
      title: t('governmentServiceEducation.subCategory'),
      dataIndex: 'subCategory',
      align: 'center',
      render: (_, record) => record && record.subCategory && record.subCategory.name,
      filters: subCategoryFilters,
      onFilter: (value, record) => record.subCategory && record.subCategory.id === value,
      filterSearch: true,
    },
    {
      title: t('governmentServiceEducation.organizationType'),
      dataIndex: 'organizationType',
      align: 'center',
      render: (_, record) => getLangField(record.orgType, 'name'),
      filters: orgTypeFilters,
      onFilter: (value, record) => record.orgType && record.orgType.id === value,
      filterSearch: true,
    },
    {
      title: t('governmentServiceEducation.action'),
      dataIndex: 'action',
      align: 'center',
      render: (_, record) => {
        return (
          <div>
            <Button type="link" onClick={handleClickEdit(record)}>
              {t('governmentServiceEducation.edit')}
            </Button>
            <Button type="link" onClick={handleClickDelete(record.id)}>
              {t('governmentServiceEducation.delete')}
            </Button>
          </div>
        );
      },
    },
  ];
};
